import React from 'react'
import Header from '../header'
import iconsquare from '../assets/images/icon-square.png'
import ashback from '../assets/images/ash-back.png'
import blackback from '../assets/images/black-back.png'
import whiteback from '../assets/images/white-back.png'
import axios from 'axios';
import config from '../config'
import * as htmlToImage from 'html-to-image';
import LoadingOverlay from 'react-loading-overlay';
class Tshirtback extends React.Component{
    constructor(props)
    {
        super(props)
        this.state={
            disablebutton: false
        }
        this.tshirtback = this.tshirtback.bind(this);
        this.tshirtbackAdd = this.tshirtbackAdd.bind(this);
        this.tshirtbackprint = this.tshirtbackprint.bind(this);
    }
    tshirtbackAdd()
    {
        this.props.history.push('/designs')
    }
    tshirtback()
    {
        this.props.history.push('/layout')
    }
    downloadPNGFromAnyImageSrc(src, hit)
    {
        var img = new Image;
        img.onload = function(){
        var canvas = convertImageToCanvas(img);
        var pngImage =  convertCanvasToImage(canvas);
        };
        img.src = src;

        function convertImageToCanvas(image) {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext("2d").drawImage(image, 0, 0);
        //alert('canvasconverter')
        return canvas;
        }
        //let imagevalue = false;
        function convertCanvasToImage(canvas) {
            var image = new Image();
                image.src = canvas.toDataURL("image/png");
                //alert('imageconverter')
                //console.log("image.src ",image.src )
                sessionStorage.setItem('prev_image',image.src)
                // var interval = setInterval(() => {
                //     if(localStorage.getItem('prev_image') != '')
                //     {
                //         imagevalue = true;
                //         clearInterval(interval);
                //     }
                // }, 200);
                if(hit ==1)
                {
            setTimeout(() => {
            let apiDynamicUrlAddress = config.default.api.host;
                let apiUrl = `${apiDynamicUrlAddress}placeOrder`
                var formData = new FormData();
                let customer_id = sessionStorage.getItem('customer_id')
                let user_id = sessionStorage.getItem('user_id')
                let material_id = sessionStorage.getItem('material_id')
                let logos = sessionStorage.getItem('logos')
                let graphics = sessionStorage.getItem('graphics')
                let alphabetblack = sessionStorage.getItem('alphabetblack')
                let alphabetblue = sessionStorage.getItem('alphabetblue')
                let alphabetlondon = sessionStorage.getItem('alphabetlondon')
                let prev_image =  image.src
                let print_image = sessionStorage.getItem('imagedata');
                let body = [{
                    "logos":logos ? logos : '',
                    "graphics":graphics ? graphics : '',
                    "alphabetblack":alphabetblack ? alphabetblack : '',
                    "alphabetblue":alphabetblue ? alphabetblue : '',
                    "alphabetlondon":alphabetlondon ? alphabetlondon :'',
                }]
                formData.append("customer_id", customer_id ? customer_id : '');
                formData.append("material_id", material_id ? material_id : '');
                formData.append("status",'order');
                formData.append("prev_image",  prev_image ?  prev_image : '');
                formData.append("print_image", print_image ? print_image : '');
                formData.append("placed_by",  user_id ? user_id : '');
                formData.append("processed_by",'');
                formData.append("json", JSON.stringify(body));
                axios.post(apiUrl ,formData, {
                    crossDomain : true,
                    enablePreflight : false
                }).then((response) => {
                    if(response.data.success == 1)
                    {
                        this.setState({
                            orderplacedvalid:true
                        })
                    }
                    else{
                        this.setState({
                            orderplacedinvalid:'Order is not Placed Successfully',
                            disablebutton : false
                        })
                    }
                })
                .catch((err) => {
                });
                }, 3000);
            }
        }
        if(hit == 1)
        {
            setTimeout(() => {
                this.props.history.push('/confirmation');
            }, 6000);
        }
    }
    tshirtbackprint(e)
    {
        e.preventDefault();
        this.setState({
            disablebutton : true
        })
        let gettempimg = sessionStorage.getItem('tempimg');
        this.downloadPNGFromAnyImageSrc(gettempimg, 1)
    }
    componentDidMount()
    {
        this.setState({
            disablebutton : true
        })
        let tempimg;
        setTimeout(() => {
            htmlToImage.toSvg(document.getElementById('preview-section'))
        .then(function (dataUrl) {
            var img = new Image();
            img.src = dataUrl;
            tempimg = img.src;
            sessionStorage.setItem('tempimg',img.src)
        });
        setTimeout(() => {
            this.downloadPNGFromAnyImageSrc(tempimg, 0)
        }, 6000);
        }, 6000);
        setTimeout(() => {
            this.setState({
                disablebutton : false
            })
        }, 14000);
    }
    render()
    {
        const{disablebutton}= this.state;
        let positionvalue = sessionStorage.getItem('imagedata')
        //let position =  JSON.parse(positionvalue)
        let selectedcolorvalue = sessionStorage.getItem('selectedTshirt');
        let selectedcolor = JSON.parse(selectedcolorvalue)
        return(
            <div>
                <div className="screen_loader">
                <LoadingOverlay
                    active={disablebutton}
                    spinner
                    text='Loading your content...'
                >
                <Header/>
                <section className="home-register-section">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12 col-lg-12">
                                <div className="home-register-form-div design-menu-sec design-logo-sec design-layout-div">
                                    <div className="form-logo-section sec-center">
                                        <a href="#/register"><img src={iconsquare} alt="logo" className="img-fluid brand-logo"/></a>
                                    </div>
                                    <h3>Mock Up</h3>
                                    <h4></h4>
                                    <div className="col-md-12 sec-center left" id="preview-section">
                                        <div className="design-mock-outer">
                                            <div className="design-mock-outer-image-box" id="tshirt-back-preview">
                                            <div className="design-mock-outer-image-box-shirt">
                                                    {
                                                    selectedcolor[0].color == 'Gray' ? 
                                                    <img src={ashback} alt="t-shirt-front" className="img-fluid"/>
                                                    :
                                                    selectedcolor[0].color == 'Black' ? 
                                                    <img src={blackback} alt="t-shirt-front" className="img-fluid"/>
                                                    :
                                                    <img src={whiteback} alt="t-shirt-front" className="img-fluid"/>
                                                    }
                                                </div>
                                                <div class="design-mock-outer-image-box-logo">
                                                    <img src={positionvalue} alt="t-shirt-icon" class="img-fluid"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 sec-center left">
                                        <div className="footer-btn footer-btn-three footer-btn-large"> 
                                        <div className="footer-left-btn"> 
                                                <button onClick={this.tshirtback} className="black_btn">Back</button>
                                            </div>
                                            <div className="footer-center-btn"> 
                                                <button onClick={this.tshirtbackAdd} className="black_btn">Add</button>
                                            </div>
                                            <div className="footer-right-btn"> 
                                                <button  onClick={this.tshirtbackprint} className="black_btn" disabled={disablebutton}>Print</button>
                                            </div>
                                        </div>
                                        {/* <div className="form-group">
                                            <div className={this.state.orderplacedvalid ? 'email-success-msg' : 'email-error-msg' }>{this.state.orderplacedvalid}</div>
                                            <div className={this.state.orderplacedinvalid ? 'email-error-msg' : 'email-error-msg' }>{this.state.orderplacedinvalid}</div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </section>
                </LoadingOverlay>
                </div>
            </div>
        )
    }
}
export default Tshirtback;